import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import Cookies from "js-cookie";
import MessageToster from "./component/MessageToster";

export const getAuthToken = () => Cookies.get("token");

let isLoggingOut = false;
let lastSessionExpiredTime = 0;

export const setManualLogout = (flag = true) => {
    isLoggingOut = flag;
    if (typeof window !== "undefined") {
        if (flag) {
            sessionStorage.setItem("manual_logout", "true");
            setTimeout(() => {
                isLoggingOut = false;
                sessionStorage.removeItem("manual_logout");
            }, 3500);
        } else {
            sessionStorage.removeItem("manual_logout");
        }
    }
};

export const isManualLogout = () => {
    return (
        isLoggingOut ||
        (typeof window !== "undefined" &&
            sessionStorage.getItem("manual_logout") === "true")
    );
};

export const useHandleUnauthorized = () => {
    const navigate = useNavigate();

    return useCallback(() => {
        // If user manually logged out, suppress "session expired" error toast
        if (isManualLogout()) {
            return;
        }

        const now = Date.now();
        // Debounce: prevent duplicate session expired triggers within 3 seconds
        if (now - lastSessionExpiredTime < 3000) {
            return;
        }
        lastSessionExpiredTime = now;

        Cookies.remove("token");
        Cookies.remove("userdata");
        Cookies.remove("username");
        sessionStorage.removeItem("mid");
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("devicetoken");
        localStorage.removeItem("devicetoken");

        MessageToster("error", "Session expired. Please log in again.", {
            id: "session_expired_alert",
        });
        setTimeout(() => navigate("/", { replace: true }), 500);
    }, [navigate]);
};

export { createAdminToken, adminDirectLogin } from "./utils/adminAuth";